module.exports = __webpack_public_path__ + "img/sbd.707f0f6c.svg";